import { AlertBox } from "./AlertBox";

/**
 * Upcoming - Uses AlertBox to show a "Coming Soon!" message.
 */
const Upcoming = ({ open, onOpenChange }) => {
  return (
    <AlertBox
      open={open}
      onOpenChange={onOpenChange}
      title="SahiClub"
      description="Coming Soon!"
      className="sm:max-w-xs"
      actions={[
        {
          label: "OK",
          value: "ok",
          variant: "action", // or 'default' depending on your AlertBox setup
          className: "sahi-primary-button", // Use your standard primary button class
        },
      ]}
      onAction={() => {
        // No specific action needed, AlertBox handles closing
        onOpenChange(false);
      }}
    />
  );
};

export default Upcoming;